import { Inbox } from "lucide-react";
import { useTranslation } from "react-i18next";
import styles from "./EmptyState.module.css";

interface EmptyStateProps {
	message?: string;
	action?: React.ReactNode;
}

export function EmptyState({ message, action }: EmptyStateProps) {
	const { t } = useTranslation();
	return (
		<div className={styles.wrapper}>
			<Inbox size={40} className={styles.icon} />
			<p className={styles.message}>{message || t("noData")}</p>
			{action && <div className={styles.action}>{action}</div>}
		</div>
	);
}
